<template>
  <div class="resultPage">
   <div class="content">
    <img src="@/assets/style/certification-icon.png" alt="">
    <span>正在获取认证结果</span>
    <span>请耐心等待，请勿离开</span>
   </div>
  </div>
</template>

<script>
export default {
  name: "resultPage",
  components: {},
  props: {
    
  },
  data() {
    return {
    };
  },
  async mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.resultPage {
  height: 480px;
}
.content{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 14px;
  img{
    width: 110px;
    height: 110px;
  }
}
</style>
